export default "__VITE_ASSET__C5s8HJ8g__"